import { useEffect, useRef, useState } from 'react';
export const usePromptsHeight = isHoverActive => {
  const [height, setHeight] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        setHeight(entry.contentRect.height);
      }
    });
    resizeObserver.observe(ref.current);
    if (ref.current) {
      setHeight(ref.current.getBoundingClientRect().height);
    }
    return () => resizeObserver.disconnect();
  }, [isHoverActive]);
  return {
    height,
    ref
  };
};